// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"SnackBar_snackbar__3sDN7","alert":"SnackBar_alert__24WIe","button":"SnackBar_button__3FdIM"};